import { useEffect } from "react";

export const LAYOUTS = {
  praia_marisco: {
    label: "Praia & marisco", font: "family=Playfair+Display:wght@600;700&family=Outfit:wght@300;400;500;600",
    heading: "'Playfair Display', serif", body: "'Outfit', sans-serif", bg: "#F5F3EE", ink: "#10202A", muted: "#5B6770",
    card: "#FFFFFF", line: "rgba(16,32,42,.09)", radius: "1.25rem", btn: "9999px", align: "center", dark: false,
  },
  tradicional: {
    label: "Tradicional cabo-verdiano", font: "family=Cormorant+Garamond:wght@600;700&family=Work+Sans:wght@400;500;600",
    heading: "'Cormorant Garamond', serif", body: "'Work Sans', sans-serif", bg: "#FAF6EF", ink: "#2A1E16", muted: "#6E5F53",
    card: "#F2EADD", line: "rgba(42,30,22,.16)", radius: "0.5rem", btn: "0.5rem", align: "left", dark: false,
  },
  lounge_noite: {
    label: "Lounge & noite", font: "family=Outfit:wght@500;700;900&family=Manrope:wght@300;400;600",
    heading: "'Outfit', sans-serif", body: "'Manrope', sans-serif", bg: "#0B0B0C", ink: "#F4F1EC", muted: "#A8A29A",
    card: "#161618", line: "rgba(255,255,255,.1)", radius: "0.25rem", btn: "0.25rem", align: "center", dark: true,
  },
  cafe_snack: {
    label: "Café & snack", font: "family=Fredoka:wght@500;600&family=Figtree:wght@400;500;600",
    heading: "'Fredoka', sans-serif", body: "'Figtree', sans-serif", bg: "#FFF7EE", ink: "#2B2420", muted: "#7A6A5E",
    card: "#FFFFFF", line: "rgba(43,36,32,.08)", radius: "1.75rem", btn: "9999px", align: "left", dark: false,
  },
};

export const layoutOf = (key) => LAYOUTS[key] || LAYOUTS.tradicional;

export function useLayoutFonts(L) {
  useEffect(() => {
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = `https://fonts.googleapis.com/css2?${L.font}&display=swap`;
    document.head.appendChild(l);
    return () => { l.remove(); };
  }, [L.font]);
}

export const cssVars = (L, pal) => ({
  "--bg": L.bg, "--ink": L.ink, "--muted": L.muted, "--card": L.card, "--line": L.line, "--r": L.radius, "--btn": L.btn,
  "--p": pal?.primary || "#0E4B47", "--a": pal?.accent || "#E0A458", "--d": pal?.dark || "#0B1F1E",
  "--fh": L.heading, "--fb": L.body, "--k": L.dark ? (pal?.accent || "#E0A458") : (pal?.primary || "#0E4B47"),
  fontFamily: L.body, background: L.bg, color: L.ink,
});

export const waUrl = (n) => {
  let d = (n || "").replace(/\D/g, "");
  if (d.startsWith("00")) d = d.slice(2);
  if (d.length === 7) d = "238" + d;
  return `https://wa.me/${d}`;
};

export const creditText = (c) => (c ? (c.via === "Google" ? `Foto: ${c.author || "Google"} via Google` : c.via ? `Foto: ${c.via}` : "") : "");
